/**
 * @description 获取组合路径
 * @param {string} currPath 当前网盘路径
 * @param {string} fullFolder 文件夹路径
 * @return {*}
 */
export const getConcatDirPath = (_currPath: string | string[], _fullFolder: string | string[]) => {
  const currPath = Array.isArray(_currPath) ? _currPath.join('/') : _currPath;
  const fullFolder = Array.isArray(_fullFolder) ? _fullFolder.join('/') : _fullFolder;
  return [currPath, fullFolder].filter(v => v).join('/');
};
